<template>
  <div class="nav-mobile" :class="{ 'nav-hidden': !open }">
    <div class="content-full-width">
      <!-- <img src="/images/nav-logo.png" alt="" /> -->
      <ul class="inner">
        <li v-if="menus['home']"><a href="/home">Home</a></li>
        <li v-if="menus['whats-on']"><a href="/whats-on">What's On</a></li>
        <li v-if="menus['news']"><a href="/news">News</a></li>
        <li v-if="menus['creature-content']"><a href="/creature-content">Creature Content</a></li>
        <li v-if="menus['oceanchampionchallenge']"><a href="/oceanchampionchallenge">Ocean Champion Challenge</a></li>
        <li v-if="menus['sponsors-supporters']"><a href="/sponsors-supporters">Sponsors & Supporters</a></li>
        <li v-if="menus['about']"><a href="/about-us">About</a></li>
        <li v-if="menus['contact-us']"><a href="/contact-us">Contact</a></li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ["open"],
  data() {
    return {
      menus: [],
    }
  },
  created() {
    this.getMenus()
  },
  methods: {
    getMenus() {
      let url = "/api/menus";
      window.axios
        .get(url)
        .then((response) => {
          if(typeof response.data.data !== 'undefined') {
            response.data.data.forEach(el => {
              this.menus[el] = true;
            });
          }

        })
        .catch((error) => {
          // this.error = error.response.data.message;
          console.log(error);
        });
    },
  }
};
</script>

<style scoped lang="scss">
.nav-mobile {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 10;

  width: 100%;
  height: 100vh;
  overflow: auto;

  background-color: #fff;
  transition: all 0.3s ease-in-out;

  img {
    width: 155px;

    margin-left: 27px;
  }

  .inner {
    display: flex;
    flex-direction: column;

    padding-left: 0;
    margin-top: 120px;

    text-align: center;

    @media (min-width: 1024px) {
      margin-top: 219px;
    }

    li a {
      font-weight: 500;
      font-size: 25px;
      line-height: 27px;

      transition: all 0.3s ease;

      color: #333333;

      &:hover {
        color: #0e7f86;
      }

      @media (min-width: 768px) {
        font-size: 55px;
        line-height: 67px;
        -webkit-text-stroke: 1px;
        letter-spacing: 1px;
        font-weight: bold;
      }
    }
  }

  .content-full-width {
    padding-top: 21px;
  }

  &.nav-hidden {
    left: 0;

    width: 0;

    overflow: hidden;
  }

  @media (min-width: 768px) {
    .inner {
      margin-top: 214px;
    }

    img {
      width: 210px;

      margin-left: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/utils/MobileNav.vue